/* 
Typical reading speed in words per minute (wpm)
-----------------------------------------------
-----------------------------------------------
Third-grade students =          150 wpm
Eighth grade students =         250 wpm
Average college student =       450 wpm
Average "high-level exec" =     575 wpm
Average college professor =     675 wpm
Speed readers =                 1,500 wpm
World speed reading champion =  4,700 wpm
Average adult =                 300 wpm 
*/

const wpm = 200

export const estimateReading = (articleBody) => {
  let result = ""

  const searchForStrings = (obj) => {
    for (let key in obj) {
      if (typeof obj[key] === "string") {
        result += obj[key] + " "
      } else if (typeof obj[key] === "object") {
        searchForStrings(obj[key])
      }
    }
  }

  articleBody.forEach((obj) => {
    searchForStrings(obj)
  })

  const stringResult = result.trim()
  const words = stringResult.split(/\s+/).length
  const time = Math.ceil(words / wpm)
  
  return time
}
